import { ListingUseType } from "../../../../components/src/services/listings.service";

import type { ListingUseTypeConfig } from "./ActivateListingsPage.types";

const LISTING_USE_TYPE_CONFIGS: ListingUseTypeConfig[] = [
  {
    useType: "Event",
  },
  {
    useType: "Off-Site",
    // an Off-Site listing can't be activated without these.
    requiredAmenityIds: ["WiFi", "Tables", "Chairs"],
  },
  {
    useType: "Production",
  },
];

const MAX_HOURLY_RATE = 99000;
const MIN_MINIMUM_DURATION_HOURS = 1;
const MAX_MINIMUM_DURATION_HOURS = 12;
const MAX_DAY_RATE_DISCOUNT_PERCENT = 50;

/** Maps `ListingUseType` to the group key EnvAPI's amenities response uses (lowercase). */
const AMENITIES_GROUP_BY_USE_TYPE: Record<
  ListingUseType,
  "events" | "offsite" | "production"
> = {
  Event: "events",
  "Off-Site": "offsite",
  Production: "production",
} as const;

/** Kebab-case slug per use type, for test IDs that need to stay unique across the three simultaneously-rendered cards/forms. */
const USE_TYPE_SLUG: Record<ListingUseType, string> = {
  Event: "event",
  "Off-Site": "off-site",
  Production: "production",
} as const;

export {
  AMENITIES_GROUP_BY_USE_TYPE,
  LISTING_USE_TYPE_CONFIGS,
  MAX_DAY_RATE_DISCOUNT_PERCENT,
  MAX_HOURLY_RATE,
  MAX_MINIMUM_DURATION_HOURS,
  MIN_MINIMUM_DURATION_HOURS,
  USE_TYPE_SLUG,
};
